import React from 'react';
import { I18n, Trans } from 'react-i18next';


export class ProposHeader extends React.Component {
  render() {
     
    return (
      <I18n ns="translations">
        {
          (t, { i18n }) => (
              <section id="eric-section">
                <div className="container">
                  <div className="row">
                    <div className="col-md-12 col-xs-12">
                      <div className="head-part" className="head-part">
                        <h1>{t('proposhead')}<span className="separator">{t('proposhead1')}</span></h1>
                        <p>{t('propospara1')}</p>
                        <p>{t('propospara2')}</p>

                      </div>          
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 col-xs-12 eric-img">
                      <img src="images/img-eric.png"/>
                    </div>
                    <div className="col-md-8 col-xs-12">
                      <div className="content-part">
                        <h3>{t('erictitle')}</h3>
                        <p>{t('ericpara1')}<b className="bold">{t('ericparabold')}</b></p>
                        <p>{t('ericpara2')}</p>
                        <p>{t('ericpara3')}<b className="bold">{t('ericpara3bold')}</b> {t('ericpara4')}<b className="bold">{t('ericbold1')}</b> {t('ericpara5')}</p>
                        <a href="https://fr.wikipedia.org/wiki/%C3%89ric_Beaumard" target="_blank" className="btn btn-default btn-style"> {t('ericbutton')}</a>
                      </div>
                    </div>
                  </div>
                  <div className="row" id="card-eric">
                    <h4><i>{t('pourtitle')}</i></h4>
                    <div className="card-eric-col">
                    <a href={t('bl1')} target="_blank">
                      <img className="card-eric-img" src="images/card_eric_01.png"/>
                      <h5>{t('pourimg1')}<br/>{t('pourimgl1')}</h5> 
                      <img className="red-arrow" src="images/ic-arrow.png"/>
                      </a>
                    </div>
                    <div className="card-eric-col">
                    <a href={t('bl2')} target="_blank">
                      <img className="card-eric-img" src="images/card_eric_02.png"/>
                      <h5>{t('pourimg2')}<br/>{t('pourimgl2')}</h5>
                      <img className="red-arrow" src="images/ic-arrow.png"/>
                    </a>
                    </div>
                    <div className="card-eric-col">
                    <a href={t('bl3')} target="_blank">
                      <img className="card-eric-img" src="images/card_eric_03.png"/>
                      <h5>{t('pourimg3')}<br/>{t('pourimgl3')}</h5>
                      <img className="red-arrow" src="images/ic-arrow.png"/>
                    </a>
                    </div>
                    <div className="card-eric-col">
                    <a href={t('bl4')} target="_blank">
                      <img className="card-eric-img" src="images/card_eric_04.png"/>
                      <h5>{t('pourimg4')}<br/>{t('pourimgl4')}</h5> 
                      <img className="red-arrow" src="images/ic-arrow.png"/>
                      </a>
                    </div>
                    <div className="card-eric-col">
                    <a href={t('bl5')} target="_blank">
                      <img className="card-eric-img" src="images/card_eric_05.png"/>
                      <h5>{t('pourimg5')}<br/>{t('pourimgl5')}</h5>
                      <img className="red-arrow" src="images/ic-arrow.png"/>
                    </a>
                    </div>
                    <div className="card-eric-col">
                    <a href={t('bl6')} target="_blank">
                      <img className="card-eric-img" src="images/card_eric_06.png"/>
                      <h5>{t('pourimg6')}<br/>{t('pourimgl5')}</h5> 
                      <img className="red-arrow" src="images/ic-arrow.png"/>
                    </a>
                    </div>
                    <div className="card-eric-col">
                    <a href={t('bl7')} target="_blank">
                      <img className="card-eric-img" src="images/card_eric_07.png"/>
                      <h5>{t('pourimg7')}<br/>{t('pourimgl7')}</h5> 
                      <img className="red-arrow" src="images/ic-arrow.png"/>
                    </a>
                    </div>
                  </div>
                </div>
              </section>
            )
         }
      </I18n>
  	)
  }
}


// WEBPACK FOOTER //
// ./src/components/Propos/Header/ProposHeader.js